import React from 'react'

export default function Skills() {
  return (
    <div id="skills" className='skillView'>
    <h2>My Skills</h2>
    <ul>
        <li>C</li>
        <li>C++</li>
        <li>HTML5</li>
        <li>CSS3</li>
        <li>Javascript</li>
        <li>React.js</li>
        <li>Firebase</li>
        <li>NodeJS</li>
        <li>ExpressJS</li>
        <li>SQL</li>
        <li>MongoDB</li>
        <li>GitHub</li>
        <li>Heroku</li>
        <li>Figma</li>
    </ul>
</div>
  )
}
